// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"ChapterPlayer_Thumb__2m-li","ThumbZoom":"ChapterPlayer_ThumbZoom__TLS48"};